<template>
  <div class="error">
      <div class="error-box">
          <div class="error-icon"><span class="blind">에러아이콘</span></div>
          <em>서비스 이용이 원활하지 않습니다.</em>
          <span>잠시 후 다시 이용해 주시기 바랍니다.</span>
      </div>
      <div class="button-wrap fixed">
<!--        <button class="button-bg-gray" @click="$router.go(-1)">이전 페이지</button>-->
        <button class="button-bg-gray" @click="goBack()">이전 페이지</button>
        <button class="button-bg-yellow" @click="goHome()">홈으로</button>
      </div>
  </div>
</template>

<script>
export default {
    name: 'ErrorPage',
    data() {
        return {

        };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from;
      });
    },
    mounted() {
      // this.$heading('');
      console.log(this.prevRoute)
    },
    methods: {
      goHome() {
        this.$router.push({name:'home'})
      },
      goBack() {
        if(this.prevRoute.name == "productDetail" || this.prevRoute.name == "orderResult" || this.prevRoute.name == "orderComplete"){
          this.$router.push({name:'home'})
        }else{
          this.$router.go(-1)
        }
      }
    }
};
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/common/error.scss';
    @import '@/assets/styles/common/bottomButton.scss';
</style>